import './styles/panelFiltros.css'
import { useState,useEffect } from 'react';
import Action from '../../Action';
import Modal from 'react-modal';


const panelFiltros = () => {
  
   
    return (
       <div id="filter-panel" class="filter-panel">
        <div class="filter-group" data-filter-group="severity">
            <label>Severidad</label>
            <div class="severity-selector" id="severidad-selector">
                <button class="severity-btn" data-value="1">1</button>
                <button class="severity-btn" data-value="2">2</button>
                <button class="severity-btn" data-value="3">3</button>
                <button class="severity-btn" data-value="4">4</button>
                <button class="severity-btn" data-value="5">5</button>
            </div>
        </div>
        
        <div class="filter-group" data-filter-group="status">
            <label>Estado (Status)</label>
            <div class="severity-selector" id="status-selector">
                <button class="severity-btn active" data-value="PROBLEMA">Problema</button>
                <button class="severity-btn" data-value="RESUELTO">Resuelto</button>
            </div>
        </div>

        <div class="filter-group" data-filter-group="techs">
            <label>Tecnologías</label>
            <div class="multi-selector-container" id="tech-selector-container">
                <div class="tags-container"></div>
                <input type="text" class="search-input" placeholder="Buscar tecnología..."/>
                <div class="options-dropdown"></div>
            </div>
        </div>

        <div class="filter-group" data-filter-group="groups">
            <label>Grupos</label>
            <div class="multi-selector-container" id="group-selector-container">
                <div class="tags-container"></div>
                <input type="text" class="search-input" placeholder="Buscar grupo..."/>
                <div class="options-dropdown"></div>
            </div>
        </div>

        <div class="filter-group" data-filter-group="zones">
            <label>Zonas</label>
            <div class="multi-selector-container" id="zone-selector-container">
                <div class="tags-container"></div>
                <input type="text" class="search-input" placeholder="Buscar zona..."/>
                <div class="options-dropdown"></div>
            </div>
        </div>

        <div class="filter-group" data-filter-group="ack">
            <label>Acuse (Ack)</label>
            <div class="severity-selector" id="ack-selector">
                <button class="severity-btn" data-value="true">Con Ack</button>
                <button class="severity-btn" data-value="false">Sin Ack</button>
            </div>
        </div>

        <div class="filter-group" data-filter-group="ticket">
            <label>Ticket</label>
            <div class="severity-selector" id="ticket-selector">
                <button class="severity-btn" data-value="true">Con Ticket</button>
                <button class="severity-btn" data-value="false">Sin Ticket</button>
            </div>
        </div>
        <div style="margin-top: 20px; text-align: right;">
            <button id="clear-filters-btn" class="btn btn-secondary">Limpiar Filtros</button>
        </div>
    </div>
    );
  };

  export default panelFiltros